'use client';

import { useState, useEffect } from 'react';
import { catalogApiCall } from '../services/api-services';
import { CatalogViewData } from '../types/catalog-view-data';

/**
 * Hook for fetching non-essential catalog data
 * @param shouldFetch - Whether to fetch the data or not
 * @returns The non-essential catalog data and loading state
 */
export const useNonEssentialCatalogData = (shouldFetch: boolean) => {
  const [data, setData] = useState<Partial<CatalogViewData> | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!shouldFetch) {
      return;
    }

    const fetchNonEssentialData = async () => {
      setIsLoading(true);
      try {
        const response = await catalogApiCall({
          endpoint: 'view/non-essential',
          method: 'GET',
        });

        if (response.success) {
          const actualData =
            response.data && response.data.data ? response.data.data : response.data;
          setData(actualData);
        } else {
          setError(new Error('Failed to fetch non-essential catalog data'));
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchNonEssentialData();
  }, [shouldFetch]);

  return { data, isLoading, error };
};
